import { useEffect, useState, useRef } from 'react';
import URL from '../../classes/Url/URL';
import Api from '../../classes/Api/Api';
import { useParams } from 'react-router-dom';
import Chart from 'react-apexcharts';

const DmrvChart = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const chartContainer = useRef(null);

  const [options, setOptions] = useState({
    chart: {
      id: 'basic-bar',
    },
    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
    },
  });

  const [series, setSeries] = useState([
    {
      name: 'series-1',
      data: [30, 40, 45, 50, 49, 60, 70, 91],
    },
  ]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const currentDate = new Date();
    const finishDate = currentDate.toISOString().split('T')[0];
    currentDate.setDate(currentDate.getDate() - 7);
    const startDate = currentDate.toISOString().split('T')[0];

    const filter = `?filter={"start_date":"${startDate}","finish_date":"${finishDate}"}`;
    const url = `${URL.URL_SERVER}/projects/${id}/dmrv${filter}`;
    const api = new Api(url);
    const response = await api.get();
    // console.log('Response:', JSON.stringify(response));
    const { data } = response;
    const { resources } = data;

    const categories = resources.map((element) => element.formatted_datetime);
    const new_data = resources.map((element) => element.formatted_co2_flux_g_m2);
    setOptions({
      chart: {
        id: 'basic-bar',
      },
      xaxis: {
        categories,
      },
      title: {
        text: 'CO\u2082 absortion / release',
        align: 'center',
        style: {
          fontSize: '20px',
        },
      },
      yaxis: {
        title: {
          text: 'CO\u2082 m2s',
          style: {
            fontSize: '16px',
          },
        },
      },
      annotations: {
        yaxis: [
          {
            y: 0,
            borderColor: 'red',
          }
        ]
      }
    });
    setSeries([
      {
        name: 'series-1',
        data: new_data,
      },
    ]);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const containerWidth = chartContainer.current.clientWidth;
      setOptions((prevOptions) => ({
        ...prevOptions,
        chart: {
          ...prevOptions.chart,
          width: containerWidth,
        },
      }));
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="app">
      <div className="row">
        <div className="mixed-chart" ref={chartContainer}>
          {loading && (
            <span
              style={{
                fontSize: '30px',
                color: '#000',
                display: 'table',
                marginTop: '25%',
                marginLeft: '20%',
              }}
            >
              Real time data will be live soon
            </span>
          )}
          {!loading && <Chart options={options} series={series} type="line" />}
        </div>
      </div>
    </div>
  );
};

export default DmrvChart;
